module.exports = __webpack_public_path__ + "static/media/notification-icon.a42cf0cf.svg";